/**
 *
 * Asynchronously loads the component for CongratulationsPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
